import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BbitPaymentRedirectState, BbitWebShopCartService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteMetaDataService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-order-result',
  templateUrl: './order-result.component.html',
  styleUrl: './order-result.component.scss',
  imports: [NgIcon, RouterLink, AsyncPipe, I18nPipe],
})
export class OrderResultComponent {
  private _meta = inject(BbitWebsiteMetaDataService);
  private _cart = inject(BbitWebShopCartService);
  private _activatedRoute = inject(ActivatedRoute);

  public BbitPaymentRedirectState = BbitPaymentRedirectState;
  public state = new BehaviorSubject(BbitPaymentRedirectState.SUCCESS);
  constructor() {
    this._activatedRoute.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.state.next(params['state'] || BbitPaymentRedirectState.SUCCESS);

      switch (this.state.value) {
        case BbitPaymentRedirectState.SUCCESS:
          this._meta.update({ title: { key: 'thankYouForYourOrder' } });
          this._cart.clear();
          break;
        case BbitPaymentRedirectState.FAILED:
          this._meta.update({ title: { key: 'errorWhileCreatingOrder' } });
          break;
        case BbitPaymentRedirectState.CANCEL:
          this._meta.update({ title: { key: 'paymentCanceled' } });
          break;
      }
    });
  }
}
